import cn from 'classnames'
import React from 'react'

import styles from './ModalPage.module.scss'

import Button from '~elements/Button'
import CloseIcon from '~icons/close.svg'

function ModalPageHeader({
  children,
  className,
  ...props
}: React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>) {
  return (
    <div className={cn(styles.header, className)} {...props}>
      {children}
    </div>
  )
}

function ModalPageBody({
  children,
  className,
  ...props
}: React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>) {
  return (
    <div className={cn(styles.body, className)} {...props}>
      {children}
    </div>
  )
}

function ModalPageFooter({
  children,
  className,
  ...props
}: React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>) {
  return (
    <div className={cn(styles.footer, className)} {...props}>
      {children}
    </div>
  )
}

interface ModalPageProps extends React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>> {
  onClose?: () => void
}

function ModalPage({ children, className, onClose, ...props }: ModalPageProps) {
  return (
    <div className={cn(styles.root, className)} {...props}>
      {onClose && <Button variant="plain" icon={<CloseIcon />} onClick={onClose} className={styles.closeButton} />}
      {children}
    </div>
  )
}

export default Object.assign(ModalPage, {
  Header: ModalPageHeader,
  Body: ModalPageBody,
  Footer: ModalPageFooter,
})
